(function(algolia) {
  'use strict';


  algolia.full_results = Boolean(window.location.href.match(/\/search/));

  // We want to match `/collections/handle` but only if handle != 'all'
  algolia.is_collection_results_page = Boolean(
    window.location.pathname.match(/^\/collections\/([^/]+)[/]*$/)
    /**
     * To match /collections/handle/handle-two links as well, please use
     * the following regex instead:
     */
    // window.location.pathname.match(/^\/collections\/(?!all)(.*)$/)
    
    // update 05-05-2021 by bilal: include /all collection as well
    // to exclude /all
	// window.location.pathname.match(/^\/collections\/(?!all$)([^/]+)[/]*$/)
  );

  /* Hide page content during InstantSearch loading */
  var collectionPage =
    Boolean(algolia.is_collection_results_page) &&
    Boolean(algolia.config.instant_search_enabled_on_collection);


  var current_collection_id_string = document.getElementById('current_collection_id').innerHTML.replace(/^\s+|\s+$/g, '');
  var isVendorPage = Boolean(document.getElementById('current_collection_template_suffix').innerHTML == 'brand');

  if (current_collection_id_string) {
    try {
      var current_collection_id_object = JSON.parse(
        current_collection_id_string
      );
      algolia.current_collection_id =
        current_collection_id_object.currentCollectionID;
    } catch (error) {
      // Encountered an error while trying to parse the collection ID.
      // This most probably means that we aren't on a collection page.
    }
  }

  var searchFilters = [];
  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;


  if (
  (!algolia.full_results && !collectionPage) ||
    !algolia.config.instant_search_enabled
  ) {
    return;
  }

    if (collectionPage) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    var handle = Boolean(matches) && matches.length === 2 ? matches[1] : null;

    if (algolia.config.collection_id_indexing) {
      collectionFacetFilter = algolia.current_collection_id
        ? 'collection_ids:"' + algolia.current_collection_id + '"'
        : null;
    } else {
      collectionFacetFilter = 'collections:"' + handle + '"';
    }

    // Add the collection filter to the list of search filters
    searchFilters.push(collectionFacetFilter);

    collectionRulesContextValue = algolia.config.collection_id_query_rules
      ? algolia.current_collection_id
      : handle;
  }

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function(k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  function singleIndex(indexName) {
    return {
      stateToRoute: function(uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return route;
      },
      routeToState: function(routeState) {
        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  // Filters for stock policy
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algolia.config.stock_policy === 'continue') {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = 'inventory_available:true';
    }

    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  var activeSortOrders =
    collectionPage && algolia.collectionSortOrders
      ? algolia.collectionSortOrders
      : algolia.sortOrders;

  const search = instantsearch({
      indexName: algolia.config.index_prefix + 'products',
      // searchClient: algoliasearch("UB7AEJB05A", "bf128b0977a6d8f598f8007a831f45a5"),
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + 'products'),
      },
      searchFunction: function(searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        if (algolia.config.show_products) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter(
            'filters',
            searchFilters.join(' AND ')
          );
        }

        // Assign any required `ruleContexts` which are required for query rules
        // targeting collection pages
        if (collectionPage) {
          // Collection page merchandising:
          // If we are on a collection page, `collectionRulesContextValue` is defined
          if (collectionRulesContextValue) {
            searchFunctionHelper.setQueryParameter('ruleContexts', [
              collectionRulesContextValue.toString(),
            ]);
          } else {
            searchFunctionHelper.setQueryParameter('ruleContexts', []);
          }
        }

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
  });



  // search hook

  // Create a render function
  const renderSearchBox = (renderOptions, isFirstRender) => {
      const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions;

      if (isFirstRender) {
          const inputbox = document.getElementsByClassName('search-bar__input')[0];

          inputbox.addEventListener('input', event => {
              refine(event.target.value);
          });
      }

      document.getElementsByClassName('search-bar__input')[0].value = query;
      // widgetParams.container.querySelector('span').hidden = !isSearchStalled;
  };

  // create custom widget
  const customSearchBox = instantsearch.connectors.connectSearchBox(
      renderSearchBox
  );

  // instantiate custom widget
  search.addWidgets([
      customSearchBox({
          container: document.querySelector('#search-box-container'),
      })
  ]);


  // 1. Create a render function
  const renderRefinementList = (renderOptions, isFirstRender) => {
      const {
          items,
          isFromSearch,
          refine,
          createURL,
          isShowingMore,
          canToggleShowMore,
          searchForItems,
          toggleShowMore,
          widgetParams,
      } = renderOptions;

      if (isFirstRender) {

              widgetParams.container.innerHTML = `
          <div class="collection__filter-group">
            <button class="collection__filter-group-name link link--secondary text--strong" data-action="toggle-collapsible" aria-controls="filter-${widgetParams.widgetName}" data-close-siblings="false" data-collapsible-force-overflow="true" aria-expanded="true">
              ${widgetParams.widgetName}
              <svg class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">
              <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>
            </svg>
            </button>
              <div id="filter-${widgetParams.widgetName}" class="collection__filter-collapsible" aria-hidden="false" style="height: auto; overflow: visible;">
                  <ul class="collection__filter-checkbox-list">

                  </ul>
                  <a class="showmore" href="#">Show more</a>
              </div>
          </div>`;

     const showMore = widgetParams.container.querySelector('a.showmore');

      showMore.addEventListener('click', () => {
        toggleShowMore();
      });

      }

      widgetParams.container.querySelector('ul').innerHTML = items.map(
              item => `<li class="collection__filter-checkbox">
                <div class="checkbox-wrapper">
                <input type="checkbox" data-value="${item.value}"
                class="${item.isRefined ? "checkbox is-selected" : "checkbox"}"
                id="${item.value}" name="tag-size"
                data-action="toggle-tag"
                data-tag="${item.value}"
                data-tag-user="${item.value}"
                ${item.isRefined ? "checked" : ""}  />
                <svg class="icon icon--check" viewBox="0 0 24 24" role="presentation">
                  <path fill="currentColor" d="M9 20l-7-7 3-3 4 4L19 4l3 3z"></path>
                </svg>
                </div>
                <label for="${item.value}">${item.value} (${item.count})</label>
        		  </li>`
          )
          .join('');

      [...widgetParams.container.querySelectorAll('input[type=checkbox]')].forEach(element => {
          element.addEventListener('click', event => {
              event.preventDefault();
              refine(event.currentTarget.dataset.value);
          });
      });

      const showMore = widgetParams.container.querySelector('a.showmore');

      if (!canToggleShowMore) {
          showMore.disabled = true;
          showMore.style.display = "none";
      } else {
          showMore.disabled = false;
          showMore.style.display = "inline-block";
      }

      showMore.textContent = isShowingMore ? 'Show less' : 'Show more';
  };



  // price range filter
  // Create the render function
  const renderRangeInput = (renderOptions, isFirstRender) => {
      const { start, range, refine, widgetParams } = renderOptions;
      const [min, max] = start;

      if (isFirstRender) {
          const form = document.createElement('form');

          form.addEventListener('submit', event => {
              event.preventDefault();

              const rawMinInputValue = parseFloat(event.target.elements.min.value);
              const rawMaxInputValue = parseFloat(event.target.elements.max.value);

              refine([
                  Number.isFinite(rawMinInputValue) ? rawMinInputValue : undefined,
                  Number.isFinite(rawMaxInputValue) ? rawMaxInputValue : undefined,
              ]);
          });

          widgetParams.container.appendChild(form);

          return;
      }

      widgetParams.container.querySelector('form').innerHTML = `
      <div class="collection__filter-group">
    <button class="collection__filter-group-name link link--secondary text--strong" data-action="toggle-collapsible" aria-controls="filter-${widgetParams.widgetName}" data-close-siblings="false" data-collapsible-force-overflow="true" aria-expanded="true">
      ${widgetParams.widgetName}
      <svg class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">
      <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>
    </svg>
    </button>
      <div id="filter-${widgetParams.widgetName}" class="collection__filter-collapsible" aria-hidden="false" style="height: auto; overflow: visible;">
        <div class="collection__filter-checkbox-list">
          <input
          type="number"
          name="min"
          placeholder="${widgetParams.placeholder}"
          class="small-textbox"
          value="${Number.isFinite(min) ? min : ''}"
          />
          <span>to</span>
          <input
          type="number"
          name="max"
          placeholder="${widgetParams.placeholder}"
          class="small-textbox"
          value="${Number.isFinite(max) ? max : ''}"
          />
          <input type="submit" class="small-submit-btn" value="Go" />
        </div>
      </div>
    </div>
    `;
  };


  function AddRefinementWidget (Name, Class, IndexAttribute)
  {
      const Connector = instantsearch.connectors.connectRefinementList(
        renderRefinementList
      );

      const widgetElements = document.getElementsByClassName(Class);

      for(const widgetElement of widgetElements){
          search.addWidgets([
            Connector({
              container: widgetElement,
              attribute: IndexAttribute,
              showMoreLimit: 20,
              showMore: true,
              widgetName: Name,
              limit: 5,
            }),
          ]);
      }
  }


  function AddRangeWidget (Name, Class, IndexAttribute, placeholderUnit)
  {
      const Connector = instantsearch.connectors.connectRange(
    renderRangeInput
  );

  const widgetElements = document.getElementsByClassName(Class);

  for(const widgetElement of widgetElements){
      search.addWidgets([
         Connector({
          container: widgetElement,
          attribute: IndexAttribute,
          placeholder: placeholderUnit,
          widgetName: Name,
          precision: 2
         }) ])
  }}

  const rating = () => {
      let stars = Math.floor(Math.random() * (5 - 3) + 3);
      let rating = '';

      for (let i = 0; i < stars; i++)
      {
          rating += '<i class="spr-icon spr-icon-star-gold"></i>';
      }
      if ( stars < 5)
      {
        for (let i = 0; i < 5 - stars; i++)
        {
        	rating += '<i class="spr-icon spr-icon-star-empty"></i>';
        }
      }

	return rating;
  }

  const handelize = (str) => {
      if (str !== undefined)
          return str.replace(/[^a-z0-9]+/gi, '-')
              .replace(/^-+/, '')
              .replace(/-+$/, '')
              .toLowerCase();
      else
          return 'all';
  }

const vendors = ["Tesoro", "Bedrosians", "Mohawk", "Happy Feet International", "From The Forest", "Emser", "US Floors", "Amorim", "Daltile"];

  // Create the render function
 const renderHits = (renderOptions, isFirstRender) => {
        const { hits, widgetParams } = renderOptions;
        widgetParams.container.innerHTML = `
        <div class="product-list product-list--collection product-list--with-sidebar">
      ${hits
        .map(
          (item) =>
            `<div class="product-item product-item--vertical  1/3--tablet-and-up 1/4--desk">
            <div class="product-item__label-list">
              <span class="product-label product-label--on-sale">Save ${Math.trunc(
                (unit_pricing(item.price, item.meta) / unit_pricing(item.compare_at_price, item.meta)) * 100
              )}%</span>
            </div>
            <a href="/collections/${handelize(item.meta.spec.product_category)}/products/${ item.handle }?variant=${item.objectID}" class="product-item__image-wrapper">
              <div class="aspect-ratio aspect-ratio--square" style="padding-bottom: 10%">
                <img class="product-item__primary-image image--fade-in lazyautosizes lazyloaded"
                  data-media-id="${item.objectID}"
                  data-src="${item.image} 200w, ${item.image}, 300w"
                  data-sizes="auto"
                  alt="${item.title} ${item.options.color}"
                  src=${item.image} 200w, ${item.image}, 300w" />
              </div>
            </a>
            <div class="product-item__info">
              <div class="product-item__info-inner">
                <a class="product-item__vendor link" href="/collections/${handelize(item.vendor)}">${item.vendor}</a>
                <a href="/collections/${handelize(item.meta.spec.product_category)}/products/${item.handle}?variant=${item.objectID}" class="product-item__title text--strong link">${item.title} ${item.options.color}</a>
                <div class="product-item__price-list price-list">
                ${item.tags.includes('sample') ? `
				  <span class="price price--highlight">$${item.price.toLocaleString('en-US', {maximumFractionDigits: 2, useGrouping:true})} Sample</span>
                  ` : `
                  <span class="price price--highlight">
                    $${unit_pricing(item.price, item.meta)}/${item.meta.pricing.price_uom.toLowerCase()}
                  </span>
                  <span class="price price--compare">$${unit_pricing(item.compare_at_price, item.meta)}/${item.meta.pricing.price_uom.toLowerCase()}</span>
                
                  `}
                </div>
                <a class="product-item__reviews-badge link" href="/collections/${handelize(item.meta.spec.product_category)}/products/${item.handle}?variant=${item.objectID}#product-reviews">
                  <span class="shopify-product-reviews-badge">
                    <div class="spr-badge">
                      <span class="spr-starrating spr-badge-starrating">
                		${rating()}
                      </span>
                    </div>
                  </span>
                </a>
                <span class="small text--strong">Free Shipping on $2000+</span>
              </div>
                ${item.tags.includes('sample') ? `
					<a href="tel:8882483320" title="Call Armand Flooring Products" class="product-item__action-button button button--small button--secondary">Call for price</a>
					<button type="button"
                     class="product-item__action-button button button--small button--ternary hidden-phone"
                     data-action="open-modal"
                     data-secondary-action="open-quick-view"
                     aria-controls="modal-quick-view-search-template"
                     data-product-url="/collections/${handelize(item.meta.spec.product_category)}/products/${item.handle}?variant=${item.objectID}">Quick view</button>
				` : `
                  <form method="post"
                    action="/cart/add"
                    id="product_form_id_${item.objectID}_collection-template"
                    accept-charset="UTF-8"
                    class="product-item__action-list button-stack"
                    enctype="multipart/form-data">

                    <input type="hidden" name="utf8" value="✓" />
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="quantity" value="1">
                    <input type="hidden" name="id" value="${item.objectID}">

                    <button type="submit"
                      class="product-item__action-button button button--small button--primary"
                      data-action="add-to-cart">Add to cart</button>
                    <button type="button"
                     class="product-item__action-button button button--small button--ternary hidden-phone"
                     data-action="open-modal"
                     data-secondary-action="open-quick-view"
                     aria-controls="modal-quick-view-search-template"
                     data-product-url="/collections/${handelize(item.meta.spec.product_category)}/products/${item.handle}?variant=${item.objectID}">Quick view</button>
                  </form>
               `}
            </div>
          </div>`
        )
        .join("")}
        </div>
  `;
};


  // Create the custom widget
  const customHits = instantsearch.connectors.connectHits(renderHits);

  // Instantiate the custom widget
  search.addWidgets([
    customHits({
      container: document.querySelector(".algolia-container"),
    }),
  ]);

  // Create the render function
  const renderPagination = (renderOptions, isFirstRender) => {
    const {
      pages,
      currentRefinement,
      nbPages,
      isFirstPage,
      isLastPage,
      widgetParams,
      refine,
      createURL,
    } = renderOptions;

    // const container = document.querySelector(".pagination");

    widgetParams.container.innerHTML = `
      <div class="pagination__inner">
    ${
      !isFirstPage
        ? `
            <a  class="pagination__prev link" rel="prev"
              href="${createURL(currentRefinement - 1)}"
              data-value="${currentRefinement - 1}"
            > <svg class="icon icon--arrow-left" viewBox="0 0 8 12" role="presentation">
            <path stroke="currentColor" stroke-width="2" d="M6 10L2 6l4-4" fill="none" stroke-linecap="square"></path>
          </svg>
              Previous
            </a>

          `
        : ""
    }
    <div class="pagination__nav">
    ${pages
      .map(
        (page) => `
            <a
              href="${createURL(page)}"
              data-value="${page}"
              class="${
                currentRefinement === page
                  ? "pagination__nav-item  is-active"
                  : "pagination__nav-item link"
              }"
            >
              ${page + 1}
            </a>
        `
      )
      .join("")}
      </div>
      ${
        !isLastPage
          ? `
              <a
              class="pagination__next link" rel="next" title="Next"
                href="${createURL(currentRefinement + 1)}"
                data-value="${currentRefinement + 1}"
              >
                Next
                <svg class="icon icon--arrow-right" viewBox="0 0 8 12" role="presentation">
                <path stroke="currentColor" stroke-width="2" d="M2 2l4 4-4 4" fill="none" stroke-linecap="square"></path>
              </svg>
              </a>
            `
          : ""
      }
  </div>
    `;

    [...widgetParams.container.querySelectorAll("a")].forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();
        refine(event.currentTarget.dataset.value);
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    });
  };

  // Create the custom widget
  const customPagination = instantsearch.connectors.connectPagination(
    renderPagination
  );

  // Instantiate the custom widget
  search.addWidgets([
    customPagination({
      container: document.querySelector(".pagination"),
    }),
  ]);


  // stats
  const renderStats = (renderOptions, isFirstRender) => {
    const { nbHits, processingTimeMS, query, widgetParams } = renderOptions;

    if (isFirstRender) {
      return;
    }

    let count = '';
    if (nbHits > 1) {
      count += `${nbHits.toLocaleString('en-US', {useGrouping:true})} products`;
    } else if (nbHits === 1) {
      count += `1 product`;
    } else {
      count += `no product`;
    }

    widgetParams.container.innerHTML = `
      Showing ${count} ${query ? `for <q>${query}</q>` : ''}
    `;
  };

  // Create the custom widget
  const customStats = instantsearch.connectors.connectStats(renderStats);

  // Instantiate the custom widget
  search.addWidgets([
    customStats({
      container: document.querySelector('.search-stats'),
    })
  ]);


  // Create the render function
  const renderHitsPerPage = (renderOptions, isFirstRender) => {
    const { items, hasNoResults, refine, widgetParams } = renderOptions;

    if (isFirstRender) {
      // widgetParams.container.innerHTML = `
      // <div class="value-picker-wrapper">
      // <button class="value-picker-button" aria-haspopup="true" aria-expanded="false" aria-controls="display-by-selector" data-action="open-value-picker">
      //    <span class="hidden-phone">Display: 24 per page</span>
      //    <svg class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">
      //       <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>
      //    </svg>
      // </button>
      // <div id="display-by-selector" class="value-picker" aria-hidden="true">
      //    <svg class="icon icon--nav-triangle-borderless" viewBox="0 0 20 9" role="presentation">
      //       <path d="M.47108938 9c.2694725-.26871321.57077721-.56867841.90388257-.89986354C3.12384116 6.36134886 5.74788116 3.76338565 9.2467995.30653888c.4145057-.4095171 1.0844277-.40860098 1.4977971.00205122L19.4935156 9H.47108938z" fill="#ffffff"></path>
      //    </svg>
      //    <div class="value-picker__inner">
      //       <header class="value-picker__header">
      //          <span class="value-picker__title text--strong">Display</span>
      //          <button class="value-picker__close" data-action="close-value-picker" aria-controls="display-by-selector" aria-label="Close">
      //             <svg class="icon icon--close" viewBox="0 0 19 19" role="presentation">
      //                <path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path>
      //             </svg>
      //          </button>
      //       </header>
      //       <div class="value-picker__choice-list">
      //       </div>
      //       </div>
      //      </div>
      //    </div>
      //   `;

      const select = widgetParams.container.querySelector('#display-by-selector');
      select.querySelectorAll("[data-action=\"select-value\"]").forEach(selection => {

        selection.addEventListener('click', function(e) {
          // prevent onSelect/click event firing from theme.js ValuePicker binding
          e.stopPropagation();

          let selectionValue = e.target.getAttribute('data-value');


          // close the popup - taken from _close function from ValuePicker class
          document.querySelector("[data-action=\"open-value-picker\"][aria-controls=\"display-by-selector\"]").setAttribute('aria-expanded', 'false');
          document.getElementById('display-by-selector').setAttribute('aria-hidden', 'true'); // This is quite ugly, but in order to avoid an issue with the header that has a higher z-index, we have to temporarily reduce
          // it while we have the element open

          var headerElement = document.querySelector('.shopify-section__header');
          headerElement.style.zIndex = '';
          document.body.classList.remove('no-mobile-scroll');

          // update the front end heading dynamically because page reload is not called
          widgetParams.container.querySelector('.currentHitsPerPage').innerHTML = 'Display: ' + selectionValue + ' per page';

          // call algolia refine function
          refine(selectionValue);

        }, true);

    });
    }

    // select.querySelector('.value-picker__choice-list').innerHTML = `
    //     ${items
    //       .map(
    //         item => `
    //         <button class="value-picker__choice-item link " data-action="select-value" data-value="${item.value}">
    //             ${item.label}
    //             <svg class="icon icon--check-2" viewBox="0 0 13 11" role="presentation">
    //             <path d="M1 4.166456L5.317719 9 12 1" stroke="currentColor" stroke-width="2" fill="none" fill-rule="evenodd"></path>
    //           </svg></button>
    //         `
    //       )
    //       .join('')}
    //   `;


      // select.disabled = hasNoResults;

  };

  // Create the custom widget
  const customHitsPerPage = instantsearch.connectors.connectHitsPerPage(
    renderHitsPerPage
  );

  // Instantiate the custom widget
  search.addWidgets([
    customHitsPerPage({
      container: document.querySelector("#hits-per-page"),
      items: [
        { label: "24 per page", value: 24, default: true },
        { label: "36 per page", value: 36 },
        { label: "48 per page", value: 48 },
        { label: "80 per page", value: 80 },
      ],
    }),
  ]);


  if (!isVendorPage)
  {
    AddRefinementWidget('Vendor', 'vendor-filter', 'vendor');
  }
  AddRefinementWidget('Species', 'species-filter', 'product_type');
  AddRefinementWidget('Color', 'color-filter', 'meta.spec.color_shade');
  AddRefinementWidget('Edges', 'edges-filter', 'meta.spec.edges');
  AddRefinementWidget('Ends', 'ends-filter', 'meta.spec.ends');
  AddRefinementWidget('Application', 'application-filter', 'meta.spec.application');
  AddRefinementWidget('Usage', 'Usage-filter', 'meta.spec.usage');
  AddRefinementWidget('Composition', 'composition-filter', 'meta.spec.composition');
  AddRefinementWidget('Construction', 'construction-filter', 'meta.spec.construction');
  AddRefinementWidget('Installation Type', 'installation-filter', 'meta.spec.installation_type');
  AddRefinementWidget('Design', 'design-filter', 'meta.spec.design');



  AddRangeWidget('Price', 'price-filter', 'meta.pricing.unit_price','$')
  AddRangeWidget('Thickness', 'thickness-filter', 'meta.spec.height', 'Inch');
  AddRangeWidget('Length', 'length-filter', 'meta.spec.height', 'Inch');
  AddRangeWidget('Width', 'width-filter', 'meta.spec.width', 'Inch');

  search.start();

  // let searchParams = new URLSearchParams(window.location.search);

  // search.setUiState({
  //   shopify_products: {
  //     query: searchParams.get("q")
  //   }
  // });
})(window.algoliaShopify);
